module.exports = __webpack_public_path__ + "img/logo9.80c4d703.png";